import { ColumnLineSignalBuffer } from "./column-line-signal-buffer";

export class ConstIsolineSignalBuffer extends ColumnLineSignalBuffer {
  constructor(settings) {
    super(settings);
  }

  tryUpdateMeanSignalValue() {
    if (this.graphicDataIndex > 0 && this.onIsolineChangeAction !== undefined) {
      this.onIsolineChangeAction(this.getData(this.graphicDataIndex));
    }
  }

  /*
  // add data without valid flag check
  // data in user units
  putData(data) {
    if (this.isoline == null) {
      this.isoline = 0;
      if (this.onIsolineChangeAction !== undefined) {
        this.onIsolineChangeAction(data);
      }
    }
    super.putData(data);
  }
  */
}
